
// Initialize ShippingBar functionality
theme.ShippingBar = (function() {

  const shippingBarMsg = document.querySelector('.drawer__free-shipping-bar--message');
  let promote_txt, unlocked_txt, treshold;

  if (shippingBarMsg) {
    promote_txt = shippingBarMsg.dataset.promote;
    unlocked_txt = shippingBarMsg.dataset.unlocked;
    treshold = shippingBarMsg.dataset.treshold;
  }

  async function update() {
    if (shippingBarMsg) {
      try {
        const url = `${theme.routes.cart}?t=${Date.now()}`;
        const response = await fetch(url, {
          credentials: 'same-origin',
          method: 'GET'
        });
        const cart = await response.json();
        const value_left = treshold - cart.total_price;
        const value_left_money = theme.Currency.formatMoney(value_left, theme.settings.moneyFormat);

        if (value_left <= 0) {
          shippingBarMsg.innerHTML = `<p>${unlocked_txt}</p>`;
        } else {
          shippingBarMsg.innerHTML = `<p>${promote_txt.replace('[value]', `<strong>${value_left_money}</strong>`)}</p>`;
        }
      } catch (error) {
        console.error('ShippingBar update error:', error);
      }
    }
  }

  return { update };
})();

// Listen for cart updates to refresh shipping bar
document.addEventListener('cart:updated', function() {
  if (theme.ShippingBar && theme.ShippingBar.update) {
    theme.ShippingBar.update();
  }
});

// Listen for product additions to refresh shipping bar
document.addEventListener('ajaxProduct:added', function() {
  // Add a small delay to ensure cart data is fully updated
  setTimeout(function() {
    if (theme.ShippingBar && theme.ShippingBar.update) {
      theme.ShippingBar.update();
    }
  }, 100);
});

/**
 * Cart Recommendations Customization
 * 
 * Extends Motion's CartForm parsing/markup to include cart recommendations markup
 * returned by templates/cart.ajax.liquid.
 */
(function() {
  'use strict';

  // Wait for the theme to be loaded
  if (typeof theme === 'undefined' || !theme.CartForm) {
    console.warn('CartRecommendations: theme.CartForm not found. Make sure this script loads after theme.js');
    return;
  }

  /**
   * Enhanced _parseProductHTML method that includes recommendations parsing
   * @param {string} html - HTML string to parse
   * @returns {Object} Parsed elements including recommendations
   */
  theme.CartForm.prototype._parseProductHTML = function(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    
    return {
      items: doc.querySelector('.cart__items'),
      recommendations: doc.querySelector('.cart__recommendations'),
      discounts: doc.querySelector('.cart__discounts')
    };
  };

  /**
   * Enhanced cartMarkup method that handles recommendations display
   * @param {string} html - HTML string containing cart markup
   */
  theme.CartForm.prototype.cartMarkup = function(html) {
    var markup = this._parseProductHTML(html);
    var items = markup.items;
    var recommendations = markup.recommendations;
    var count = parseInt(items.dataset.count);
    var subtotal = items.dataset.cartSubtotal;
    var savings = items.dataset.cartSavings;

    this.updateCartDiscounts(markup.discounts);
    this.updateSavings(savings);

    if (count > 0) {
      this.wrapper.classList.remove('is-empty');
    } else {
      this.wrapper.classList.add('is-empty');
    }

    this.updateCount(count);

    // Append item markup
    this.products.innerHTML = '';
    this.products.append(items);
    
    // Add recommendations if they exist and contain items
    if (recommendations && recommendations.querySelector('.recommendation__item')) {
      this.products.append(recommendations);
    }

    // Update subtotal
    this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

    this.reInit();

    if (window.AOS) { 
      AOS.refreshHard(); 
    }

    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  /**
   * On cart drawer open, rebuild cart content (Motion-compatible hook).
   */
  document.addEventListener('drawerOpen.CartDrawer', function() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  });
})();

/**
* Quantity Change Event Enhancement for Sticky ATC
* 
* This script adds the missing quantity:change event to the theme's QtySelector class
* to enable proper synchronization between main product form and sticky add-to-cart bar.
* 
* The existing sticky ATC code already handles the synchronization, but it needs
* the quantity:change event to be fired by the QtySelector class.
*/

(function() {
'use strict';

// Wait for DOM to be ready and ensure theme is loaded
function initQuantityChangeEvent() {
  // Check if theme object exists (indicating theme.js has loaded)
  if (typeof theme === 'undefined') {
    setTimeout(initQuantityChangeEvent, 100);
    return;
  }

  // Override the theme's QtySelector _change method to add custom event
  if (theme.QtySelector && theme.QtySelector.prototype) {
    const originalChange = theme.QtySelector.prototype._change;
    
    theme.QtySelector.prototype._change = function(qty) {
      if (qty <= this.minValue) {
        qty = this.minValue;
      }

      // Fire custom quantity:change event
      var evt = new CustomEvent('quantity:change');
      this.input.value = qty;
      this.input.dispatchEvent(evt);

      // Call original functionality
      if (this.options.isCart) {
        document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
            detail: [this.options.key, qty, this.wrapper]
        }));
      }
    };
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuantityChangeEvent);
} else {
  initQuantityChangeEvent();
}

})();

// Sticky ATC & Recharge
// Delay initialization to prevent getBoundingClientRect from causing scroll during Recharge widget load
function initStickyAtc() {
  if( !document.querySelector('.sticky-atc') ) return;

  var stickyAtc = document.querySelector('.sticky-atc');

  var atcButton = document.querySelector('.product-single__form .add-to-cart');
  var atcButtonClone = stickyAtc.querySelector('.add-to-cart');
  if( atcButton && atcButtonClone ) {
    atcButtonClone.addEventListener('click', function(e){
      e.preventDefault();
      atcButton.click();
    });
  }

  var qtyInput = document.querySelector('.product-single__form input[name="quantity"]');
  var qtyInputClone = stickyAtc.querySelector('input[name="quantity"]');

  qtyInput.addEventListener('quantity:change', function(){
    qtyInputClone.value = qtyInput.value;
  });
  qtyInputClone.addEventListener('quantity:change', function(){
    qtyInput.value = qtyInputClone.value;
  });

  var scrollTop = document.documentElement.scrollTop || window.pageYOffset;
  var scrollCutoff = atcButton.offsetHeight + atcButton.getBoundingClientRect().top + scrollTop + 20;

  function checkStickyAtcScroll(){
    scrollTop = document.documentElement.scrollTop || window.pageYOffset;
    if( scrollTop > scrollCutoff ) {
      stickyAtc.classList.add('visible');
    } else {
      stickyAtc.classList.remove('visible');
    }
  }

  window.addEventListener('scroll', checkStickyAtcScroll);
  setTimeout(function(){
    checkStickyAtcScroll();
  }, 100);
}

// Initialize sticky ATC after a delay to avoid getBoundingClientRect causing scroll issues
// during page load when Recharge widget is still rendering
setTimeout(initStickyAtc, 250);



var subscriptionBoxHeight = 0;
var isInitialRechargeSetup = true; // Flag to prevent scroll manipulation on page load

function createStickySubscriptionBox(rcWidget){
var subsDropdown = rcWidget.querySelector('.rc-selling-plans-dropdown');
if( document.querySelector('.rc-selling-plans') ) {
  subscriptionBoxHeight = document.querySelector('.rc-selling-plans').offsetHeight;
}
var stickyWrap = document.querySelector('.sticky-atc');
var stickySubscriptionWrap = stickyWrap.querySelector('.sticky-atc__subscription-wrap');
if( subsDropdown && !stickySubscriptionWrap.querySelector('.rc-selling-plans-dropdown') ) {
  var subsDropdownClone = subsDropdown.cloneNode(true);
  stickySubscriptionWrap.querySelector('.rc-radio__label').appendChild(subsDropdownClone);
}
if( !stickySubscriptionWrap.querySelector('.rc-save-text') ) {
  var saveText = document.createElement('div');
  saveText.classList.add('rc-save-text');
  saveText.innerHTML = theme.strings.subscriptionInfo;
  stickySubscriptionWrap.querySelector('.rc-radio__subscription').appendChild( saveText ) ;
}
}

function createRechargeStickyAtc(rcWidget){
var stickyWrap = document.querySelector('.sticky-atc');
stickyWrap.classList.add('with-recharge');
var stickyOneTimeWrap = stickyWrap.querySelector('.sticky-atc__onetime-wrap');
var stickySubscriptionWrap = stickyWrap.querySelector('.sticky-atc__subscription-wrap');

var oneTimeRadio = rcWidget.querySelector('.onetime-radio');
var subsRadio = rcWidget.querySelector('.subscription-radio'); 

var oneTimeRadioClone = oneTimeRadio.cloneNode(true);
oneTimeRadioClone.querySelector('input').setAttribute('id', 'sticky-onetime');
oneTimeRadioClone.querySelector('input').setAttribute('name', 'stickyPurchaseOption');
oneTimeRadioClone.setAttribute('for', 'sticky-onetime');
stickyOneTimeWrap.appendChild(oneTimeRadioClone);

var subsRadioClone = subsRadio.cloneNode(true);
subsRadioClone.querySelector('input').setAttribute('id', 'sticky-subscription');
subsRadioClone.querySelector('input').setAttribute('name', 'stickyPurchaseOption');
subsRadioClone.setAttribute('for', 'sticky-subscription');
stickySubscriptionWrap.appendChild(subsRadioClone);

createStickySubscriptionBox(rcWidget);

oneTimeRadio.addEventListener('click', function(e){
  subsRadioClone.classList.remove('rc-radio--active');
  oneTimeRadioClone.classList.add('rc-radio--active');
  oneTimeRadioClone.querySelector('input').checked = true;
});
oneTimeRadioClone.addEventListener('click', function(e){
  e.preventDefault();
  var savedScrollPos = window.pageYOffset;
  if( subsRadioClone.classList.contains('rc-radio--active') ) {
    subsRadioClone.classList.remove('rc-radio--active');
    oneTimeRadioClone.classList.add('rc-radio--active');
    savedScrollPos = savedScrollPos - subscriptionBoxHeight;
  }
  oneTimeRadioClone.querySelector('input').checked = true;
  oneTimeRadio.click();
  // Only manipulate scroll position if not during initial setup
  if (!isInitialRechargeSetup) {
    window.scrollTo(0, savedScrollPos);
    setTimeout(function(){
      window.scrollTo(0, savedScrollPos);
    }, 0);
  }
});

subsRadio.addEventListener('click', function(e){
  oneTimeRadioClone.classList.remove('rc-radio--active');
  subsRadioClone.classList.add('rc-radio--active');
  subsRadioClone.querySelector('input').checked = true;
});

subsRadioClone.addEventListener('click', function(e){
  e.preventDefault();
  if( e.target.nodeName != 'SELECT' ) {
    var savedScrollPos = window.pageYOffset;
    if( oneTimeRadioClone.classList.contains('rc-radio--active') ) {
      oneTimeRadioClone.classList.remove('rc-radio--active');
      subsRadioClone.classList.add('rc-radio--active');  
      savedScrollPos = savedScrollPos + subscriptionBoxHeight;
    }
    subsRadioClone.querySelector('input').checked = true;
    subsRadio.click();
    // Only manipulate scroll position if not during initial setup
    if (!isInitialRechargeSetup) {
      window.scrollTo(0, savedScrollPos);
      setTimeout(function(){
        window.scrollTo(0, savedScrollPos);
      }, 0);
    }
  }
});


var subsDropdownCloneSelect = document.querySelector('.sticky-atc select');
if( subsDropdownCloneSelect ) {
  subsDropdownCloneSelect.addEventListener('change', function(){
    document.querySelector('.sticky-atc .subscription-radio').click();
    setTimeout(function(){
      rcWidget.querySelector('.rc-selling-plans select').value = subsDropdownCloneSelect.value;
      rcWidget.querySelector('.rc-selling-plans select').dispatchEvent(new Event('change'));
    }, 0);
  });
}
}

function prepareSubscriptionBox(rcWidget){
var subsPlans = rcWidget.querySelector('.rc-selling-plans');
if( subsPlans ) {
  if( !subsPlans.querySelector('.rc-save-text') ) {
    var saveText = document.createElement('div');
    saveText.classList.add('rc-save-text');
    saveText.innerHTML = theme.strings.subscriptionInfo;
    subsPlans.appendChild( saveText ) ;
  }
  var subsPrefix = subsPlans.querySelector('.rc-selling-plans-dropdown__label');
  var subsOptions = subsPlans.querySelectorAll('select option');
  subsOptions.forEach(function(subsOption){
    var newSubsText = subsOption.innerText.replace(subsPrefix.innerText + ' ', '');
    if( newSubsText.indexOf(theme.strings.subscriptionRecommended) > -1 && newSubsText.indexOf(theme.strings.subscriptionRecommendedText) == -1 ) {
      newSubsText = newSubsText + ' ' + theme.strings.subscriptionRecommendedText;
    }
    subsOption.innerText = newSubsText;
  });
  if( !subsPlans.querySelector('.rc-terms-text') ) {
    var terms = document.createElement('div');
    terms.classList.add('rc-terms-text');
    terms.innerHTML = theme.strings.subscriptionTerms;
    subsPlans.appendChild( terms ) ;
  }

  var subsDropdwonSelect = subsPlans.querySelector('select');
  var subsDropdownCloneSelect = document.querySelector('.sticky-atc select');
  subsDropdwonSelect.addEventListener('change', function(){
    if( subsDropdownCloneSelect ) {
      subsDropdownCloneSelect.value = subsDropdwonSelect.value;
    }
  });
}

}
function reChargeLoaded(rcWidget) {
  const priceBlock = document.querySelector('.product-section .product-block--price')
  if(priceBlock) {
    priceBlock.classList.add('hide');
  }

  var oneTimeRadio = rcWidget.querySelector('.onetime-radio');
  var subsRadio = rcWidget.querySelector('.subscription-radio');

var oneTimeLabel = oneTimeRadio.querySelector('.rc-radio__label');
var oneTimeLabelText = oneTimeLabel.innerText.split(theme.strings.currencySign);
if( oneTimeLabel.innerText.indexOf('US$') > -1 ) {
  oneTimeLabelText = oneTimeLabel.innerText.split('US$');
}

oneTimeLabel.innerHTML = '<span class="rc-radio__subscription">' + oneTimeLabelText[0] + '</span><span class="rc-radio__price">' + theme.strings.currencySign + oneTimeLabelText[1] + '</span>';

var subsRadioLabel = subsRadio.querySelector('.rc-radio__label');
var subsRadioPrice = subsRadioLabel.querySelector('.rc-radio__price');
subsRadioPrice.innerHTML = '<s>' + theme.strings.currencySign + oneTimeLabelText[1] + '</s>' + '<span>' + subsRadioPrice.innerText.replace('US$', theme.strings.currencySign) + '</span>';

var subsRadioText = subsRadio.querySelector('.rc-radio__subscription');
subsRadioText.innerText = theme.strings.subscriptionLabel;

subsRadio.addEventListener('click', function(){
  setTimeout(function(){
    prepareSubscriptionBox(rcWidget);
  }, 0);
});

// Prevent radio buttons from being focusable during initialization to stop mobile browsers
// from auto-scrolling to them when .click() is called programmatically
var subsRadioInput = subsRadio.querySelector('input');
var oneTimeRadioInput = oneTimeRadio.querySelector('input');
if (subsRadioInput) subsRadioInput.setAttribute('tabindex', '-1');
if (oneTimeRadioInput) oneTimeRadioInput.setAttribute('tabindex', '-1');

// Remove focus from any currently focused element to prevent scroll-on-blur behavior
if (document.activeElement && document.activeElement !== document.body) {
  document.activeElement.blur();
}

var scrollBeforeSubsClick = window.pageYOffset;
subsRadio.click();
// Immediately restore scroll position after click to prevent mobile scroll-to-element behavior
window.scrollTo(0, scrollBeforeSubsClick);

setTimeout(function(){
  prepareSubscriptionBox(rcWidget);
  
  setTimeout(function(){
    createRechargeStickyAtc(rcWidget);
    
    var scrollBeforeOneTimeClick = window.pageYOffset;
    oneTimeRadio.click();
    // Immediately restore scroll position after click
    window.scrollTo(0, scrollBeforeOneTimeClick);
    
    // Re-enable focus on radio buttons after initialization
    if (subsRadioInput) subsRadioInput.removeAttribute('tabindex');
    if (oneTimeRadioInput) oneTimeRadioInput.removeAttribute('tabindex');
    
    // Reset the flag after initial setup is complete to allow scroll manipulation on user interactions
    setTimeout(function(){
      isInitialRechargeSetup = false;
    }, 100);
  }, 0);
}, 0);

}

/**
 * Wait for Recharge widget to be fully rendered before initializing customizations
 * The widget needs to be present, have its radio buttons rendered, AND have price content populated
 */
var reChargeCheckInterval = setInterval(function(){
  var rcWidget = document.querySelector('.rc-widget');
  if( rcWidget ) {
    var oneTimeRadio = rcWidget.querySelector('.onetime-radio');
    var subsRadio = rcWidget.querySelector('.subscription-radio');
    
    // Check that radio buttons exist AND have price content (not empty)
    if( oneTimeRadio && subsRadio ) {
      var oneTimeLabel = oneTimeRadio.querySelector('.rc-radio__label');
      var subsLabel = subsRadio.querySelector('.rc-radio__label');
      
      // Ensure labels have actual content (prices are populated)
      if( oneTimeLabel && subsLabel && 
          oneTimeLabel.innerText.trim().length > 5 && 
          subsLabel.innerText.trim().length > 5 ) {
        
            clearInterval(reChargeCheckInterval);
            
            // Add an additional small delay to ensure widget is fully settled before our code runs
            setTimeout(function(){
              reChargeLoaded(rcWidget);
            }, 50);
      }
    }
  }
}, 100);


if( document.getElementById('CartDrawer') ) {
document.getElementById('CartDrawer').addEventListener('click', function(e){
  var target = e.target;

  if( target.classList.contains('cart__item--remove') || target.closest('.cart__item--remove') ) {
    e.preventDefault();
    if( target.closest('.cart__item--remove') ) {
      target = target.closest('.cart__item--remove');
    }
    var qtyInput = target.closest('.cart__item').querySelector('.cart__item--qty input');
    var key = qtyInput.dataset.id;
    theme.cart.changeItem(key, 0)
      .then(function(cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function(XMLHttpRequest){})
      .finally(function() {
        // Update shipping bar after item removal
        if (theme.ShippingBar && theme.ShippingBar.update) {
          theme.ShippingBar.update();
        }
      });
  } else if( document.querySelector('.cart__recommendations') ) {
    if( target.classList.contains('recommendation__item--atc') ) {
      e.preventDefault();
      target.classList.add('btn--loading');
      var id = target.getAttribute('data-id');
      fetch(theme.routes.cartAdd, {
        method: 'POST',
        body: JSON.stringify({
          'items': [{
           'id': id,
           'quantity': 1
           }]
         }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(data) {
        if (data.status === 422) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: data.description
            }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: data,
              addToCartBtn: target
            }
          }));
        }
        if (document.body.classList.contains('template-cart')) {
          window.scrollTo(0, 0);
          location.reload();
        }
        theme.ShippingBar.update();
      })
      .catch(function(error) {
      })
      .finally(function() {
        target.classList.remove('btn--loading');
      });
    } else if ( target.classList.contains('cart__recommendations--arrow') || target.closest('.cart__recommendations--arrow') ) {
      e.preventDefault();
      if( target.closest('.cart__recommendations--arrow') ) {
        target = target.closest('.cart__recommendations--arrow')
      }
      //console.log('arrow!', target);
      var list = document.querySelector('.cart__recommendations--list');
      var currentScroll = list.scrollLeft;
      var els = list.querySelectorAll('.recommendation__item');
      var elWidth = els[0].offsetWidth + els[0].style.marginRight + els[0].style.marginLeft;
      var currentIndex = Math.round(currentScroll / elWidth);
      var newIndex = currentIndex;
      if( target.getAttribute('data-arrow') == 'left' ) {
        document.querySelector('.cart__recommendations--arrow[data-arrow="right"]').classList.remove('inactive');
        newIndex--;
      } else {
        document.querySelector('.cart__recommendations--arrow[data-arrow="left"]').classList.remove('inactive');
        newIndex++;
      }
      if( newIndex <= 0 ) {
        newIndex = 0;
        document.querySelector('.cart__recommendations--arrow[data-arrow="left"]').classList.add('inactive');
      }
      if( newIndex >= els.length - 2 ) {
        newIndex = els.length - 2;
        document.querySelector('.cart__recommendations--arrow[data-arrow="right"]').classList.add('inactive');
      }
      var newScroll = newIndex * elWidth;
      list.scrollLeft = newScroll;
    }
  }
});
}